import { subDays, toDate } from "date-fns";

import { useSelectedLocation } from "components/DealersAndLocationsDropdown/hooks";
import { setLeadsCarsFilters, useLeadsCarsFilters } from "modules/LeadsDashboard/Leads/CarsLeads/hooks";
import { LEADS_CARS_STORAGE_KEYS } from "modules/LeadsDashboard/storageKeys";
import { PAGE_SIZE, setPreference } from "utils/common";

import type { DealersLocationsDropdownValue } from "components";

export const useCarsFilterHandlers = () => {
  const { selectedLocation } = useSelectedLocation();
  const carsFilters = useLeadsCarsFilters();

  const handleResetFilters = () => {
    setPreference(LEADS_CARS_STORAGE_KEYS.DealerPreference, []);
    setPreference(LEADS_CARS_STORAGE_KEYS.LeaseCompanyPreference, null);
    setPreference(LEADS_CARS_STORAGE_KEYS.DateFromPreference, subDays(new Date(), 30));
    setPreference(LEADS_CARS_STORAGE_KEYS.DateToPreference, toDate(new Date()));
    setPreference(LEADS_CARS_STORAGE_KEYS.LocationPreference, selectedLocation?.id ? [selectedLocation.id] : []);
    setPreference(LEADS_CARS_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25);

    setLeadsCarsFilters({
      ...carsFilters,
      page: 1,
      dealer_ids: [],
      search_term: "",
      is_lease_company: null,
      date_from: subDays(new Date(), 30),
      date_to: toDate(new Date()),
      location_ids: selectedLocation?.id ? [selectedLocation.id] : [],
      page_size: PAGE_SIZE.PageSize25
    });
  };

  const handleSearchChange = (value: string) => setLeadsCarsFilters({ ...carsFilters, search_term: value, page: 1 });

  const handleDealerLocationChange = ({ dealerIds, locationIds }: DealersLocationsDropdownValue) => {
    setPreference(LEADS_CARS_STORAGE_KEYS.DealerPreference, dealerIds);
    setPreference(LEADS_CARS_STORAGE_KEYS.LocationPreference, locationIds);
    setLeadsCarsFilters({ ...carsFilters, dealer_ids: dealerIds, location_ids: locationIds, page: 1 });
  };

  const handleDateRangeChange = (...dates: (Date | null)[]) => {
    const [start, end] = dates;

    setPreference(LEADS_CARS_STORAGE_KEYS.DateFromPreference, start);
    setPreference(LEADS_CARS_STORAGE_KEYS.DateToPreference, end);
    setLeadsCarsFilters({ ...carsFilters, date_from: start, date_to: end, page: 1 });
  };

  return { carsFilters, handleResetFilters, handleSearchChange, handleDealerLocationChange, handleDateRangeChange };
};
